import React from 'react';
import { LobbyLoadingInfoWr } from '../lobbyLoadingInfoWr/index.js';

var TableLoading = function (_a) {
    var bgImage = _a.bgImage, progress = _a.progress, gameLogo = _a.gameLogo, isAdditionalLoading = _a.isAdditionalLoading, additionalImgSrc = _a.additionalImgSrc; _a.forLoading; var lobbyName = _a.lobbyName, tableText = _a.tableText, logoPG = _a.logoPG;
    return (React.createElement("div", { className: 'pgc-loading', style: { backgroundImage: "url(".concat(bgImage, ")") } },
        React.createElement("div", { className: 'pgc-loading-content' },
            React.createElement(LobbyLoadingInfoWr, { gameLogo: gameLogo },
                React.createElement("h3", { className: 'pgc-common-room-name' }, lobbyName),
                React.createElement("p", { className: 'pgc-room-info-text' }, tableText),
                !isAdditionalLoading
                    ? React.createElement("div", { className: 'pgc-loading-row' },
                        React.createElement("span", { style: { width: "".concat(progress, "%") } }))
                    : React.createElement("div", { className: "bog-loader-outer" },
                        React.createElement("div", { className: "bog-loader-inner" },
                            React.createElement("img", { src: additionalImgSrc, alt: "" }),
                            React.createElement("div", { className: "bog-loader-row" },
                                React.createElement("div", { className: "bog-loader-line", style: { transform: "translateX(-".concat(100 - progress, "%)") } }))))),
            React.createElement("div", { className: 'pgc-loading-logo-holder' },
                React.createElement("img", { src: logoPG, alt: "logo" })))));
};

export { TableLoading };
